import React, { useState } from 'react';
import { ClipboardCopyIcon, Cross2Icon, InstagramLogoIcon } from '@radix-ui/react-icons';

/**
 * Replaces the multi-line alert() that used to explain the Instagram flow.
 * Inline so the caption stays on screen while the user switches to Instagram.
 */
const InstagramShareTips = ({ caption, copied, onClose }) => {
  const [justCopied, setJustCopied] = useState(false);

  const copyCaption = async () => {
    try {
      await navigator.clipboard.writeText(caption);
      setJustCopied(true);
    } catch (error) {
      setJustCopied(false);
    }
  };

  return (
    <div className="instagram-tips">
      <button type="button" className="instagram-tips-close" onClick={onClose} aria-label="Close Instagram instructions">
        <Cross2Icon />
      </button>
      <h4>
        <InstagramLogoIcon style={{ marginRight: '8px' }} />
        Your image was downloaded
      </h4>
      <ol className="instagram-tips-steps">
        <li>Open the Instagram app</li>
        <li>Tap + to create a new post</li>
        <li>Pick the image from your Downloads folder</li>
        <li>Paste the caption below</li>
      </ol>
      <textarea className="instagram-tips-caption" value={caption} readOnly rows={3} />
      <button type="button" className="btn btn-secondary" onClick={copyCaption}>
        <ClipboardCopyIcon style={{ marginRight: '6px' }} />
        {justCopied || copied ? 'Caption copied' : 'Copy caption'}
      </button>
    </div>
  );
};

export default InstagramShareTips;
